import React, { useEffect, useState } from "react";
import { Modal, Table, Alert, Tag } from "antd";

interface PreviewMemberModalProps {
  open: boolean;
  onClose: () => void;
  estimatedMember: any[];
  isDetailPage?: boolean;
}

const PreviewMemberModal: React.FC<PreviewMemberModalProps> = ({
  open,
  onClose,
  estimatedMember,
  isDetailPage,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const isMobile = window.innerWidth < 768;

  useEffect(() => {
    if (open) {
      setCurrentPage(1);
    }
  }, [open]);
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={isMobile ? 400 : 800}
      style={{ top: 0 }}
      title={
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span>Preview Members</span>
          <Tag color="blue">{estimatedMember.length} Members</Tag>
        </div>
      }>
      {/* Info alert */}
      {!isDetailPage && (
        <Alert
          type="warning"
          showIcon
          style={{ marginBottom: 16 }}
          message="Member data may change if campaign criteria are updated. Please reload to refresh the estimation."
        />
      )}

      {/* Table */}
      <Table
        className="table-preview"
        size="small"
        scroll={{ x: 600 }}
        rowKey={(_, index) => index!}
        dataSource={estimatedMember}
        pagination={{
          current: currentPage,
          defaultPageSize: 10,
          showSizeChanger: false,
          onChange: (page) => setCurrentPage(page),
          showTotal: (total, range) =>
            `Results per Page ${range[1] - range[0] + 1} of ${total} Members`,
        }}
        columns={[
          {
            title: "No",
            width: !isMobile ? 60 : "5%",
            render: (_: any, __: any, index: number) =>
              (currentPage - 1) * pageSize + index + 1,
          },
          {
            title: "Name",
            render: (_: any, record: any) => {
              const fullName =
                `${record.FirstName ?? ""} ${record.LastName ?? ""}`.trim();
              return fullName || record.Name || "-";
            },
          },

          {
            title: "Customer Contact",
            render: (_: any, record: any) =>
              record.ContactIdd && record.ContactNumber
                ? `(${record.ContactIdd}) ${record.ContactNumber}`
                : "-",
          },
          {
            title: "Email Address",
            dataIndex: "Email",
            render: (val: string) => val || "-",
          },
        ]}
      />
    </Modal>
  );
};

export default PreviewMemberModal;
